import PropTypes from 'prop-types';

import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { clone } from 'lodash';

import { resourceOperations } from '../../../redux/resource';
import { configOperations } from '../../../redux/config';
import { fetchResources, fetchManyResources} from '../../../esri/mapHub';

import DataGrid from '../../common/DataGrid';
import DataGridHeader from '../../common/DataGrid/DataGridHeader';
import ColumnChooser from '../../common/DataGrid/ColumnChooser';
import gridDefinition from '../../../defaults/datagrids/resources.json';

import IconButton from 'material-ui/IconButton';
import FlatButton from 'material-ui/FlatButton';
import CloseIcon from 'material-ui/svg-icons/navigation/close';

import FilterContainer from '../../filter/FilterContainer';
import FreeformFilterItem from '../../filter/FreeformFilterItem';
import ResourceSqlFilterDialog from './ResourceSqlFilterDialog';


import {
  formatAttribute,
  applyFieldObjectOverrides
} from '../../../utils/helpers';
import { getDomainFilter, getFreeformFilter } from '../../../esri/queryUtils';
import initFilter from '../../../defaults/filter/filter.json';

import theme from '../../../muiTheme';


class AircraftPanel extends Component {
  constructor() {
    super();
    this.state = {
      loading: null,
      resources: [],
      isMore: true,
      resourceCount: 0,
      showSqlFilterDialog: false,

      gridDefinition
    };
  }

  componentDidMount() {

    const filterState = {
      freeformSearch: initFilter.resourceSearch
    };
    this.props.setInitialResourceFilter(filterState);
    this.updateGridDefinitionFields();


  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.fields !== this.props.fields ||
      prevProps.resourceListColumns !== this.props.resourceListColumns ||
      prevProps.preferences.resourceListColumns !==
        this.props.preferences.resourceListColumns
    ) {
      this.updateGridDefinitionFields();
    }
  }

  updateGridDefinitionFields() {
    let resourceListColumns = this.props.resourceListColumns;
    if (
      this.props.preferences &&
      this.props.preferences.resourceListColumns &&
      this.props.preferences.resourceListColumns.length
    ) {
      resourceListColumns = this.props.preferences.resourceListColumns;
    }

    const gridDefinitionFields = this.getGridDefinitionFields(
      resourceListColumns
    );

    this.setState({
      gridDefinition: {
        ...this.state.gridDefinition,
        fields: gridDefinitionFields,

      }
    });
  }

  getGridDefinitionFields(resourceListColumns) {
    // loop over resourceListColumns,
    // lookup fields definition object from this.props.fields,
    // and return a new array
    // (intended to update the array used in this.state.gridDefinition.fields)
    if (this.props.fields) {
      return resourceListColumns.map(
        columnName => this.props.fields[columnName]
      );
    }

    return [];
  }

  updateResourceList = (resources, resourceCount, isMore) => {
    this.setState({ resources, resourceCount, isMore });
    this.resourcesHaveLoaded();
  };

  resourcesHaveLoaded = () => {
    this.setState({ loading: false });
  };

  resourcesAreLoading = () => {
    this.setState({ loading: true });
  };

  getBaseQuery(filters, sql) {
    const filterClauses = Object.keys(filters)
      .filter(key => {
        return filters[key].values.length;
      })
      .map(key => {
        const filter = filters[key];
        const clauses = filter.fieldNames.map(fieldName => {
          if (filter.type === 'freeform') {
            return getFreeformFilter(fieldName, filter.values);
          }
          return getDomainFilter(fieldName, filter.values);
        });
        return clauses.join(' OR ');
      });

    if (!this.state.gridDefinition.baseQuery && !filterClauses.length) {
      return null;
    }

    const filterGroupClause = filterClauses.length
      ? `(${filterClauses.join(' AND ')})`
      : null;

    const baseClause = this.state.gridDefinition.aircraftQuery
        ? `(${this.state.gridDefinition.aircraftQuery})`
        : null;
     const dispatchClause = 'currentDispatchUnit =' + this.props.resource.currentDispatchID
        ? 'currentDispatchUnit =' + `'${this.props.resource.currentDispatchID}'`
        : null;

      const baseQuery = [filterGroupClause, baseClause, dispatchClause, sql && sql.filter]
          .filter(q => q)
          .join(' AND ');

    return baseQuery;

  }

  getActions = () => {
    return [
      <IconButton
        tooltip="View Resource"
        tooltipPosition="bottom-left"
        key="viewResourceBtn"
      >
        <i className="grid-action-icon esri-icon-review" />
      </IconButton>
    ];
  };

  toggleQuickFilter = () => {
    this.setState({ showQuickFilter: !this.state.showQuickFilter });
  };

  showSqlFilterDialog = () => {
    this.setState({ showSqlFilterDialog: true });
  };

  updateQuickFilter = filter => {
    this.props.updateResourceFilterValues(filter);
  };

  handleSqlFilterUpdated = sql => {
    this.props.updateResourceSqlFilter({ ...sql });
    this.setState({ showSqlFilterDialog: false });
  };

  handleSaveSqlFilter = (name, filter) => {
    this.props.addResourceSqlFilter({ name, filter });
  };

  handleRenameSqlFilter = (existingFilterName, newFilterName) => {
    this.props.renameResourceSqlFilter({ existingFilterName, newFilterName });
  };

  handleDeleteSqlFilter = filterName => {
    this.props.removeResourceSqlFilter(filterName);
  };


  getSqlClearFilter = () => {
    if (!this.props.sql || !this.props.sql.filter) return null;

    return (
      <FlatButton
        backgroundColor={this.getSqlBackgroundColor()}
        style={styles.sqlClearFilterBtn}
        icon={<CloseIcon style={styles.sqlClearFilterIcon} />}
        onClick={() => this.handleSqlFilterUpdated(null)}
      />
    );
  };

  getSqlBackgroundColor = () => {
    if (!this.props.sql || !this.props.sql.filter) {
      return theme.palette.canvasColor;
    }

    return '#efefef';
  };

  getSqlDialog = fields => {
    if (!this.state.showSqlFilterDialog) return null;

    const fieldDefs = clone(fields);

    // Remove "faked" fields as they would result in an invalid query
    delete fieldDefs.POOLatitude;
    delete fieldDefs.POOLongitude;

    return (
      <ResourceSqlFilterDialog
        savedFilters={this.props.preferences.resourceSqlFilters}
        filterState={this.props.sql && this.props.sql.filterState}
        fieldDefinitions={fieldDefs}
        onCancel={() => this.setState({ showSqlFilterDialog: false })}
        onSubmit={this.handleSqlFilterUpdated}
        onSaveFilter={this.handleSaveSqlFilter}
        onRenameFilter={this.handleRenameSqlFilter}
        onDeleteFilter={this.handleDeleteSqlFilter}
      />
    );
  };

  render() {
    const {
      loading,
      resources,
      resourceCount,
      isMore,
      gridDefinition
    } = this.state;
    const {
      filters,
      sql,
      fields,
      addResourceListColumn,
      removeResourceListColumn,
      setInitialResourceListColumns,
      } = this.props;
    const propsStyle = this.props.style;
    const { dataGridOptions } = this.props.appConfig;
    const mapLoaded = this.props.map.loaded;

    const freeformSearchFilter = this.props.filters.freeformSearch
      ? this.props.filters.freeformSearch
      : initFilter.resourceSearch;

    if (!mapLoaded) {
      return null;
    }

    if (fields) {
      applyFieldObjectOverrides(fields, 'resource');
    }

    let filterContainer;
    if (this.state.showQuickFilter) {
      filterContainer = <FilterContainer />;
    }
   AircraftPanel.propTypes = {
      selectedPanel: PropTypes.string
    };
     AircraftPanel.defaultProps = {
      selectedPanel: ''
    };

    return (


      <Fragment>
        <div aria-labelledby="aircraft-panel"  hidden={this.props.selectedPanel !== "aircraft"}>
        <div style={styles.headerWrapper}>
          <DataGridHeader
            title="Aircraft"
            badgeColor={theme.palette.primary1Color}
            itemCount={resourceCount}
          />

          <div style={styles.headerControlsWrapper}>
            <div style={styles.filterWrapper}>
              {this.getSqlDialog(fields)}
              <FreeformFilterItem
                filterName={freeformSearchFilter.name}
                label={freeformSearchFilter.label}
                fieldNames={freeformSearchFilter.fieldNames}
                type={freeformSearchFilter.type}
                values={freeformSearchFilter.values}
                onChange={this.updateQuickFilter}
              />
              <FlatButton
                style={{ marginLeft: '1rem' }}
                backgroundColor={this.getSqlBackgroundColor()}
                label="SQL Filter"
                labelStyle={styles.sqlFilterBtn}
                onClick={this.showSqlFilterDialog}
              />
              {this.getSqlClearFilter()}
            </div>
          </div>
        </div>
        {filterContainer}

        <DataGrid
          api="resource"
          style={propsStyle}
          baseQuery={this.getBaseQuery(filters, sql)}
          badgeColor={theme.palette.primary1Color}
          pollInterval={dataGridOptions.pollingInterval}
          fieldDefinitions={gridDefinition.fields}
          defaultSort={gridDefinition.defaultSort}
          fetchItems={fetchResources}
          loading={loading}
          items={resources}
          itemCount={resourceCount}
          isMore={isMore}
          pageSize={dataGridOptions.defaultPageSize}
          attributeFormatter={formatAttribute}
          updateItems={this.updateResourceList}
          onLoadStart={this.resourcesAreLoading}
          onLoadComplete={this.resourcesHaveLoaded}
          actions={this.getActions()}
          actionsHeader={
            <ColumnChooser
              columns={fields}
              selectedColumns={gridDefinition.fields}
              addColumn={addResourceListColumn}
              removeColumn={removeResourceListColumn}
              reorderColumn={addResourceListColumn}
              resetColumns={setInitialResourceListColumns}
            />
          }
        />
        </div>
      </Fragment>
    );
  }
}

const styles = {
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: '0 0 50px',
    zIndex: '10',
    background: '#ffffff',
    borderTop: '1px solid #e5e5e5',
    borderBottom: '1px solid #e5e5e5'
  },
  headerControlsWrapper: {
    display: 'flex',
    flex: '1 0 300px',
    marginLeft: '36px'
  },
  filterWrapper: {
    display: 'flex',
    alignItems: 'center',
    flex: '1 0 300px'
  },
  sqlFilterBtn: {
    padding: '8px'
  },
  sqlClearFilterBtn: {
    minWidth: '28px'
  },
  sqlClearFilterIcon: {
    width: '18px',
    height: '18px'
  }
};



const mapStateToProps = state => ({
  map: state.map,
  appConfig: state.config,
  filters: state.resource.filters,
  sql: state.resource.sql,
  fields: state.resource.fields,
  dataGridFilters: state.dataGridFilters,
  resourceListColumns: state.resource.resourceListColumns,
  preferences: state.config.preferences,
  resource:{
    currentDispatchID: state.resource.currentDispatchID
  },
  });

const mapDispatchToProps = function(dispatch) {
  return bindActionCreators(
    {
      ...resourceOperations,
      ...configOperations
    },
    dispatch
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AircraftPanel)
);



// WEBPACK FOOTER //
// ./src/components/dispatches/ResourcePanels/AircraftPanel.js